<template>
  <div class="relative ms-3">
    <Dropdown align="right" width="48">
      <template #trigger>
        <button
          v-if="user.image_url"
          class="flex flex-shrink-0 text-sm rounded-full border-2 border-transparent transition focus:outline-none focus:border-gray-300"
        >
          <img class="object-cover rounded-full size-8" :src="user.image_url" :alt="user.name" />
        </button>
        <button
          v-else
          type="button"
          class="inline-flex flex-1 flex-shrink-0 items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 truncate bg-white rounded-md border border-transparent transition duration-150 ease-in-out dark:text-gray-400 dark:bg-gray-800 hover:text-gray-700 dark:hover:text-gray-300 focus:outline-none focus:bg-gray-50 dark:focus:bg-gray-700 active:bg-gray-50 dark:active:bg-gray-700"
        >
          {{ truncatedName }}

          <svg
            class="ms-2 -me-0.5 size-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </button>
      </template>

      <template #content>
        <div class="block px-4 py-2 text-xs text-gray-400 sm:text-sm">Manage Account</div>

        <DropdownLink :to="{ name: ROUTES.PROFILE }"> Profile </DropdownLink>

        <div class="border-t border-gray-200 dark:border-gray-600" />

        <!-- Authentication -->
        <DropdownLink as="button" @click="logout"> Log Out </DropdownLink>
      </template>
    </Dropdown>
  </div>
</template>

<script setup>
import Dropdown from '@/components/general/Dropdown.vue'
import DropdownLink from '@/components/general/DropdownLink.vue'
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'
import { ROUTES } from '@/router/routeNames'
import { useRouter } from 'vue-router'
import { ref, computed } from 'vue'

const router = useRouter()
const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

const isLoggingOut = ref(false)

const truncatedName = computed(() => {
  if (!user.value?.name) return ''
  return user.value.name.length > 12
    ? user.value.name.slice(0, 12) + '...'
    : user.value.name
})

const logout = async () => {
  if (isLoggingOut.value) return // Prevent multiple clicks

  isLoggingOut.value = true
  try {
    // Use the authStore directly for a more reliable logout
    const authStore = useAuthStore()
    await authStore.logout()
    // The redirect is handled in the authStore
  } catch (error) {
    console.error('Logout failed:', error)
    // Fallback to route-based logout if direct logout fails
    router.push({ name: ROUTES.LOGOUT })
  } finally {
    isLoggingOut.value = false
  }
}
</script>

<style lang="scss" scoped></style>
